module.exports = __webpack_public_path__ + "static/img/news-20220824.c30e69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20220824.png
// module id = TF+V
// module chunks = 0